import React from 'react'
import { Link } from 'react-router-dom'

type BaseOutlineButtonProps = {
  children: React.ReactNode
  className?: string
  disabled?: boolean
}

type ButtonOutlineButtonProps = BaseOutlineButtonProps &
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    href?: never
  }

type LinkOutlineButtonProps = BaseOutlineButtonProps & {
  href: string
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick'>

// TODO: replace with SecondaryButton
export function OutlineButton(props: ButtonOutlineButtonProps): JSX.Element
export function OutlineButton(props: LinkOutlineButtonProps): JSX.Element
export function OutlineButton(
  props: ButtonOutlineButtonProps | LinkOutlineButtonProps
) {
  const { children, className, disabled, ...restProps } = props
  const baseClassName = `p-2 text-black rounded-[14px] outline outline-1 outline-[--lines] text-center min-h-12 px-4 py-1 leading-8 ${
    disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-mydra-gray'
  } ${className ?? ''}`

  // Check if it's a link by checking for href property
  if ('href' in props && props.href) {
    const isExternal =
      props.href.startsWith('http') || props.href.startsWith('mailto:')

    if (isExternal) {
      return (
        <a href={props.href} onClick={props.onClick} className={baseClassName}>
          {children}
        </a>
      )
    } else {
      return (
        <Link to={props.href} onClick={props.onClick} className={baseClassName}>
          {children}
        </Link>
      )
    }
  }

  // It's a button - we know restProps is ButtonHTMLAttributes here due to overloads
  return (
    // @ts-expect-error - union type props spreading issue
    <button {...restProps} className={baseClassName} disabled={disabled}>
      {children}
    </button>
  )
}
